import { PropsWithChildren } from "react";
import { useLocation, useRouteLoaderData } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "@/api/user";
import { ROUTES } from "@/constants/routes";
import { HomeLoaderResponse } from "@/interfaces/loaders";
import { UserInfo } from "@/interfaces/authentication";
import { CUSTOM_MSG } from "@/constants/messages";
import { canAccessDelegatedPath } from "@/lib/delegationRouteAccess";
import PageError from "@/routes/PageError";
import Spinner from "@/components/graphics/Spinner";

const DelegatedRouteGuard = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const loaderData = useRouteLoaderData(ROUTES.homeIndex.id) as
    HomeLoaderResponse | undefined;

  const { data: queriedUserInfo, isLoading } = useQuery<UserInfo>({
    queryKey: ["userInfo"],
    queryFn: getUserInfo,
    enabled: !loaderData?.userInfo,
  });

  const userInfo = loaderData?.userInfo ?? queriedUserInfo;

  if (loaderData?.delegatedAccessDenied) {
    return <PageError msg={CUSTOM_MSG.unauth} />;
  }

  if (!userInfo && isLoading) {
    return (
      <div className="container-xxl my-7">
        <Spinner size={24} label="Henter bruger..." />
      </div>
    );
  }

  if (userInfo && !canAccessDelegatedPath(pathname, userInfo)) {
    return <PageError msg={CUSTOM_MSG.unauth} />;
  }

  return <>{children}</>;
};

export default DelegatedRouteGuard;
